import { useEffect } from 'react';
import {useNavigate} from "react-router-dom";

const SaveTokenAndRedirect = () => {
    const navigate = useNavigate();

    useEffect(() => {
        // Получение параметров "token" и "mail" из URL
        const searchParams = new URLSearchParams(window.location.search);
        const token = searchParams.get('token');
        const mail = searchParams.get('mail');
        const avatar = searchParams.get('avatar');

        // Сохранение параметров в localStorage
        localStorage.setItem('token', token);
        localStorage.setItem('mail', mail);
        localStorage.setItem('avatar', avatar);

        // Перенаправление на страницу "/"
        navigate('/');
    }, [navigate]);

    return null;
};

export default SaveTokenAndRedirect;